module.exports = __webpack_public_path__ + "img/header_bg.2a0a7927.png";